// Decision Memory Candidate API
import Ajax from '../js/common/ajax';

export default {
  /**
   * 查询候选列表
   */
  listCandidates(params) {
    return Ajax.get('/decision-memory/candidates', params);
  },

  /**
   * 查询候选详情
   */
  getCandidate(detailId) {
    return Ajax.get('/decision-memory/candidates/' + detailId);
  },

  /**
   * 排除候选
   * @param {string} comment 排除原因说明
   */
  excludeCandidate(detailId, comment) {
    return Ajax.post('/decision-memory/candidates/' + detailId + '/exclude', { reason: comment });
  },

  /**
   * 恢复候选
   * @param {string} comment 恢复原因说明
   */
  restoreCandidate(detailId, comment) {
    return Ajax.post('/decision-memory/candidates/' + detailId + '/restore', { reason: comment });
  },

  /**
   * 标记候选为 ready
   * @param {string} comment 标记原因说明
   */
  markReadyCandidate(detailId, comment) {
    return Ajax.post('/decision-memory/candidates/' + detailId + '/mark-ready', { reason: comment });
  }
};
